// @flow
import { creativityMediaModel } from '../../../../../services/creativityMediaModel'

const productImage = require('./estrellaDammMug.jpg')
const allTwoEs = require('./static-3.jpg')
const allTwoCa = require('./static-3-Ca.jpg')
const allFourEs = require('./static-3.jpg')
const allFourCa = require('./static-3-Ca.jpg')
const catalogTwoEs = require('./static-3.jpg')
const catalogTwoCa = require('./static-3-Ca.jpg')
const catalogFourEs = require('./static-3.jpg')
const catalogFourCa = require('./static-3-Ca.jpg')

const model = creativityMediaModel({
  catalogID: 'glassware',
  allTwoEs,
  allTwoCa,
  allFourEs,
  allFourCa,
  catalogTwoEs,
  catalogTwoCa,
  catalogFourEs,
  catalogFourCa
})

type Params = {
  catalogID: string,
  numberOfColumns: number,
  language: string
}

export default {
  productImage,
  creativityMedia: (params: Params) =>
    model[params.catalogID][params.numberOfColumns][params.language]
}
